// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__75C4J","name":"styles_name__3E5RC","phone":"styles_phone__sB7MI"};